import { getCookie, decryptAes, dateInterfere } from '../../../utils';

export default object => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  console.log(object)

  return {
    id: null,
    reference: object.id,
    sourceId: object.id,
    source: 'voter',
    status: 'pending',
    description: `Lembrete eleitor ${object.id} - ${object.name}.`,
    taskDate: dateInterfere({
      date: new Date(),
      quantity: 5,
      interval: 'days',
    }),
    notify: false,
    participants: [decipher?.user?.id],
  }
};
